"use strict";
/// <reference types="bootstrap"/>
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var tab_1 = __importDefault(require("bootstrap/js/dist/tab"));
var Tab = /** @class */ (function () {
    function Tab(config) {
        this.config = config;
        this.run();
    }
    Tab.prototype.run = function () {
        var _this = this;
        this.instance = this.createInstance(this.config.element);
        this.config.element.addEventListener('click', function (event) {
            event.preventDefault();
            _this.instance.show();
        });
    };
    Tab.prototype.createInstance = function (triggerEl) {
        return new tab_1.default(triggerEl);
    };
    Tab.prototype.getInstance = function () {
        return this.instance;
    };
    return Tab;
}());
exports.Tab = Tab;
